const toHex = (c) => {
  if (!c) return null;
  const m = c.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
  if (!m) return c;
  return `#${[m[1], m[2], m[3]].map((v) => parseInt(v, 10).toString(16).padStart(2, '0')).join('')}`;
};

const mergeRuns = (runs) =>
  runs.reduce((acc, r) => {
    if (!r.text) return acc;
    const last = acc[acc.length - 1];
    if (last && (last.color || null) === (r.color || null)) last.text += r.text;
    else acc.push(r.color ? { text: r.text, color: r.color } : { text: r.text });
    return acc;
  }, []);

export const runsOf = (el) => {
  const text = el.text || '';
  if (Array.isArray(el.runs) && el.runs.length && el.runs.map((r) => r.text).join('') === text) return el.runs;
  return [{ text }];
};

export const hasRichColors = (el) => runsOf(el).some((r) => r.color);

const BLOCK = new Set(['DIV', 'P', 'LI']);

export const domToRuns = (root) => {
  const runs = [];
  const colorOf = (node) => {
    let n = node.parentNode;
    while (n && n !== root) {
      const c = n.style?.color || (n.getAttribute && n.getAttribute('color'));
      if (c) return toHex(c);
      n = n.parentNode;
    }
    return null;
  };
  const walk = (node) => {
    const kids = Array.from(node.childNodes);
    kids.forEach((child, idx) => {
      if (child.nodeType === 3) runs.push({ text: child.nodeValue, color: colorOf(child) });
      else if (child.nodeName === 'BR') {
        if (!(idx === kids.length - 1 && (BLOCK.has(node.nodeName) || node === root))) runs.push({ text: '\n' });
      } else if (child.nodeType === 1) {
        if (BLOCK.has(child.nodeName) && runs.length) runs.push({ text: '\n' });
        walk(child);
      }
    });
  };
  walk(root);
  const merged = mergeRuns(runs);
  return { text: merged.map((r) => r.text).join(''), runs: merged.some((r) => r.color) ? merged : undefined };
};

export const colorSelection = (root, color, range) => {
  let r = range;
  if (!r || r.collapsed || !root.contains(r.commonAncestorContainer)) {
    r = document.createRange();
    r.selectNodeContents(root);
  }
  const span = document.createElement('span');
  span.style.color = color;
  span.appendChild(r.extractContents());
  span.querySelectorAll('[style], font').forEach((n) => { if (n.style) n.style.color = ''; n.removeAttribute('color'); });
  r.insertNode(span);
  const nr = document.createRange();
  nr.selectNodeContents(span);
  const sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(nr);
  root.focus();
  return nr;
};

export const retargetRuns = (runs, newText) => {
  const old = runs.map((r) => r.text).join('');
  const colors = [];
  runs.forEach((r) => { for (let i = 0; i < r.text.length; i += 1) colors.push(r.color || null); });
  let p = 0;
  while (p < old.length && p < newText.length && old[p] === newText[p]) p += 1;
  let q = 0;
  while (q < old.length - p && q < newText.length - p && old[old.length - 1 - q] === newText[newText.length - 1 - q]) q += 1;
  const fill = colors[p - 1] ?? colors[p] ?? null;
  const next = [...colors.slice(0, p), ...Array(Math.max(0, newText.length - p - q)).fill(fill), ...colors.slice(old.length - q)];
  const out = [];
  for (let i = 0; i < newText.length; i += 1) out.push({ text: newText[i], color: next[i] });
  return mergeRuns(out);
};

export const charColors = (el, uppercase) => {
  const runs = runsOf(el);
  if (!runs.some((r) => r.color)) return null;
  const arr = [];
  runs.forEach((r) => {
    const t = uppercase ? r.text.toUpperCase() : r.text;
    for (let i = 0; i < t.length; i += 1) arr.push(r.color || null);
  });
  return arr;
};

export const PRESET_COLORS = ['#ffffff', '#000000', '#EAB308', '#A855F7', '#10b981', '#f43f5e', '#3b82f6', '#f97316'];
